export const formatCurrency = (amount, decimals) => {

    if (decimals == 0) {
        return `${Math.ceil(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
    }

    return `${amount.toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
}